import { debounce } from "@/lib/utils";
import { RhIcon, RhSelect } from "@rhythm-ui/react";
import React from "react";

import { Chip } from "../utils/Chip";

type GenericType<T> = {
  values: T;
  valueKey: keyof T;
  apiCall: (input: string, callback: any) => Promise<any>;
  setReactState: React.Dispatch<React.SetStateAction<T>>;
  isMulti?: boolean;
  getOptionLabel?: (data: any) => any;
  menuIsOpen?: boolean | undefined;
  placeholder?: string;
  onInputChange?: (newValue: string) => void;
  className?: string;
  getChipLabel?: (data: any) => any;
  __onOptionAdd?: () => void;
};

const DataSelect = <T extends object>({
  values,
  valueKey,
  apiCall,
  setReactState,
  isMulti,
  getOptionLabel,
  menuIsOpen = undefined,
  placeholder,
  onInputChange,
  className,
  getChipLabel,
  __onOptionAdd,
}: GenericType<T>) => {
  const loadOptions = debounce(apiCall, 700);

  const selectedValues = (values[valueKey] || []) as { id: number }[];

  const onChangeHandler = (value: any) => {
    setReactState((state: T) => ({
      ...state,
      [valueKey]: value,
    }));

    if (__onOptionAdd) __onOptionAdd();
  };

  const removeItemByID = (itemId: number) => {
    const newSelectedCity = selectedValues?.filter(
      (item: { id: number }) => item.id !== itemId,
    );
    setReactState((state: T) => ({
      ...state,
      [valueKey]: newSelectedCity,
    }));
  };

  return (
    <div className={className}>
      <RhSelect
        instanceId={valueKey.toString()} //https://github.com/JedWatson/react-select/issues/2629
        menuIsOpen={menuIsOpen}
        isClearable={false}
        value={selectedValues}
        placeholder={placeholder || "Search"}
        backspaceRemovesValue={false}
        onChange={onChangeHandler}
        getOptionLabel={(data: any) =>
          getOptionLabel ? getOptionLabel(data) : data?.name
        }
        getOptionValue={(data: any) => data?.id}
        isMulti={isMulti}
        hideSelectedOptions={isMulti}
        controlShouldRenderValue={!isMulti}
        async
        loadOptions={loadOptions}
        cacheOptions
        defaultOptions={true}
        onInputChange={onInputChange}
        menuPortalTarget={
          typeof window !== "undefined" &&
          document.querySelector("#theme-provider")
        }
        menuPlacement="auto"
        components={{
          IndicatorSeparator: () => null,
        }}
      />

      {isMulti && (
        <div className="flex flex-wrap [&>*]:mr-2 [&>*]:mt-2">
          {selectedValues?.map((item: any) => {
            return (
              <Chip
                key={item?.id}
                shape={"circle"}
                size={"sm"}
                className="flex gap-tpico"
                onClick={() => removeItemByID(item?.id)}
                //   data-testid="added-location"
              >
                {getChipLabel ? getChipLabel(item) : item?.name}
                <RhIcon icon="tabler:x"></RhIcon>
              </Chip>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default DataSelect;
